import CollectionPayload from '@libraries/api/footer';
import FetchData from '@utils/fetch-data';
import { notification } from 'antd';
import { history, IFetchData } from 'asumsi-components';
import { Dispatch, SetStateAction, useState } from 'react';

export default function useAction() {
    const [isLoader, setIsLoader]: [boolean, Dispatch<SetStateAction<boolean>>] = useState(false);
    const [data, setData]: [
        any,
        Dispatch<SetStateAction<any>>,
    ] = useState();

    const getData = async () => {
        const payload: IFetchData = CollectionPayload.read();

        setIsLoader(true);

        try {
            const response: any = await FetchData({ ...payload });
            setData(response.data.data);
            setIsLoader(false);
        } catch (error) {
            const { response } = error;
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal mengambil data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    const postData = async (params: any) => {
        const payload: IFetchData = CollectionPayload.post(params);

        setIsLoader(true);

        try {
            await FetchData({ ...payload });
            setIsLoader(false);
            notification.success({
                message: 'Berhasil',
                duration: 5,
                description: 'Berhasil simpan data',
            });
            history.push({
                pathname: '/settings/footer',
            });
        } catch (error) {
            const { response } = error;
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "gagal menyimpan data",
                duration: 5,
                message: 'Failed',
            });
        }
    };

    return {
        data,
        getData,
        isLoader,
        setIsLoader,
        postData
    };
}



// WEBPACK FOOTER //
// ./src/pages/footer-form/hooks/useAction.tsx